module.exports = __webpack_public_path__ + "after-pay.6a802a016fbe25472f7bbcd1832d1298.svg";